import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    memberCount: ({ count }: {
        count: number;
    }) => string | React.ReactNode;
    inactive: string;
    restricted: string;
    project: string;
    contextMenuLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Member count display with pluralization */
            memberCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }) => __intl__.intl().formatMessage({ id: "ProjectListItem.memberCount?c=17p5u7xoeoh49", defaultMessage: "{count, plural, one {1 member} other {{count} members}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for inactive/archived project */
            inactive: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectListItem.inactive?c=3qlvs15rvt0ww", defaultMessage: "Inactive Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for restricted/private project */
            restricted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectListItem.restricted?c=2jogax91p3ad3", defaultMessage: "Restricted Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for project type */
            project: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectListItem.project?c=1y2semxo3c9fl", defaultMessage: "Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for project context menu button */
            contextMenuLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectListItem.contextMenuLabel?c=zzoojadwmz4j", defaultMessage: "Project context menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
